import script from "./OrderEditinformation.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderEditinformation.vue?vue&type=script&setup=true&lang=js"

import "./OrderEditinformation.vue?vue&type=style&index=0&id=7543bdc7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7543bdc7"]])

export default __exports__